import { ContactMeButton } from "Components/Form/ContactMeButton/ContactMeButton";
import { useTexts } from "Components/TextContext";
import { AlertDescription } from "Components/TextContext/commonComponentEnums";
import { useA11yTexts } from "Store/texts/hooks";
import { useUnleashFeatureFlag } from "Utils/unleash";
import { FeatureFlagTask } from "Utils/unleash/flags";
import React from "react";
import ReactMarkdown from "react-markdown";
import { InlineP } from "./styled";

export interface Props {
  customPrefix?: string;
  customPhoneNumber?: string;
  customSuffix?: string;
  showAsPartOfHint?: boolean;
}

export const AccessibleCallUsMessage = ({
  customPrefix,
  customPhoneNumber,
  customSuffix,
  showAsPartOfHint = false,
}: Props): React.ReactElement => {
  const [
    {
      callUsHint: { prefix, suffix, phoneNumber },
    },
    lang,
  ] = useA11yTexts();
  const { getText } = useTexts();
  const contactMeToggle = useUnleashFeatureFlag(
    FeatureFlagTask.SSX_1881_CONTACT_ME,
  );

  const prefixText = customPrefix || prefix[lang];
  const phone = customPhoneNumber || phoneNumber[lang];
  const suffixText = customSuffix || suffix[lang];

  const Message = (): React.ReactElement => (
    <>
      {" "}
      {prefixText + " "}
      <a aria-label="telefonnummer" href={"tel:" + phone}>
        {phone}
      </a>
      {" " + suffixText}
    </>
  );

  if (contactMeToggle) {
    return (
      <>
        <ReactMarkdown>{getText(AlertDescription.CONTACT_US)}</ReactMarkdown>
        <ContactMeButton />
      </>
    );
  }

  return showAsPartOfHint ? (
    <span>
      <Message />
    </span>
  ) : (
    <InlineP>
      <Message />
    </InlineP>
  );
};
